'use strict';

angular.module('saturdayBall').controller('HomeController', HomeController);

HomeController.$inject = ['$scope', '$routeParams'];

function HomeController($scope, $routeParams) {
}
